"use client";

import { useConsultation } from "../../../../context/ConsultationContext";
import styles from "../../Consultations/css/consultation-header.module.css";

export default function MedicalHistoryHeader({ 
  variant = "medical-history",
  title = "",
  patient: patientProp = null,
}) {
  const { consultationData } = useConsultation();
  const patient = patientProp || consultationData?.patient || {};
  
  const initials = `${patient.firstname?.[0] || ""}${patient.surname?.[0] || ""}`.toUpperCase();

  return (
    <div className={`${styles.headerCard} ${styles[variant]}`}>
      {/* Left Side - Patient Info */}
      <div className={styles.headerLeft}>
        <div className={styles.avatar}>{initials || ""}</div>
        <div className={styles.patientInfo}>
          <div className={styles.nameRow}>
            <h2 className={styles.patientName}>
              {(patient.firstname || "").trim() || "—"} {(patient.surname || "").trim() || ""}
            </h2>
            <span className={styles.badge}>Dependent</span>
          </div>
          <p className={styles.profileNumber}>
            Profile: {patient.profilenumber || "—"}
          </p>
        </div>
      </div>

      {/* Right Side - Title */}
      <div className={styles.headerRight}>
        <div className={styles.stepHeaderContent}>
          <h2 className={styles.stepTitle}>{title}</h2>
        </div>
      </div>
    </div>
  );
}
